export default "__VITE_ASSET__B277kIt2__"